module.exports = __webpack_public_path__ + "img/accessory_hat_10.69f98a6c.svg";